export enum ViewType {
    CREATE = "create",
    LIST = "list",
    EDIT = "update",
    SEARCH = "search",
    COMMANDS = "listCommands",
    UPDATE_COMMANDS = "updateCommands",
}
